import { Component, OnInit } from '@angular/core';
import { General_Config } from '../General_Config';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { ModalController } from '@ionic/angular';
import { ConfigdetailPage } from '../configdetail/configdetail.page';

@Component({
  selector: 'app-config',
  templateUrl: './config.page.html',
  styleUrls: ['./config.page.scss'],
})
export class ConfigPage implements OnInit {
  isLoading: boolean = true;
  page: number = 1;
  qry: string = null;
  image_base: string = General_Config.image_base;
  order_by: string = 'con.ID-desc';
  disableLoader: boolean = false;
  data: any = [];
  constructor(public modalController: ModalController, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) {
    General_Config.active_page = 'Config';
  }

  ngOnInit() { }

  ionViewWillEnter() {
    this.loadData(null);
  }

  loadData(event) {
    if (event == null) {
      this.disableLoader = false;
      this.page = 1;
    } else {
      this.page = this.page + 1;
    }
    this.restApi.get('config/' + this.qry + '/' + this.order_by + '/' + this.page).subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        if (event == null) {
          this.data = data['data'];
          if (data['data'].length < 20) {
            this.disableLoader = true;
          }
        } else {
          Array.prototype.push.apply(this.data, data['data']);
        }
        if (event != null) {
          if (data['data'].length < 20) {
            this.disableLoader = true;
          } else {
            event.target.complete();
          }
        }
      } else {
        if (event == null) {
          this.data = [];
        }
        this.disableLoader = true;
      }
    }, (error: any) => {
      this.isLoading = false;
      this.disableLoader = true;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  async openDetail(code) {
    const modal = await this.modalController.create({
      component: ConfigdetailPage,
      cssClass: '',
      componentProps: { code: code }
    });
    modal.onDidDismiss().then(data => {
      if (data.data && data.data.success && data.data.success == true) {
        this.loadData(null);
      }
    });
    return await modal.present();
  }
}
